import * as THREE from "three";

const CROSS_ORIGIN_MODE = "anonymous";

if (THREE.DefaultLoadingManager.crossOrigin !== CROSS_ORIGIN_MODE) {
  THREE.DefaultLoadingManager.crossOrigin = CROSS_ORIGIN_MODE;
}

export const withCrossOrigin = (loader) => loader.setCrossOrigin(CROSS_ORIGIN_MODE);
